module.exports = __webpack_public_path__ + "static/main_bg2-4fe9918cdd6df64b9f29803dc7f5ccc7.svg";